import { Sliders } from "@phosphor-icons/react";
import React from "react";
import Slider from "react-slick";

const ReviewTop = () => {

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-one-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }
    function SamplePrevArrow(props) {
        const { className, onClick } = props;

        return (

            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-one-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }

    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
    };


    return (
        <div className="reviewtop">
            <div className="container">
                <h5 className="text-center mt-50 mb-70">Grow Your Business WIth Us</h5>
                <div className="card position-relative reviewtopcontainer overflow-hidden border-0" style={{minHeight:"434px", padding:"36px 0px"}}>
                    <Slider {...settings} style={{zIndex:"1"}}>

                        <div className="d-flex align-items-center justify-content-center reviewslider" key={"1"}>
                            <div className="photo" style={{ backgroundImage: "url('assets/images/thumbs/review1.jpg')" }}>
                                <img src=""></img>
                            </div>
                            <div className="caption">
                                <div className="captiontop mb-20">
                                    “Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. .”
                                </div>
                                <div className="caption-bottom">
                                    <div>
                                        <span className="Name">Christine Ng, </span>
                                        <span> FnB Enterpreneur</span>
                                    </div>
                                    <div>
                                        Singapore
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-center reviewslider" key={"1"}>
                            <div className="photo" style={{ backgroundImage: "url('assets/images/thumbs/review1.jpg')" }}>
                                <img src=""></img>
                            </div>
                            <div className="caption">
                                <div className="captiontop  mb-20">
                                    “Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. .”
                                </div>
                                <div className="caption-bottom">
                                    <div>
                                        <span className="Name">Christine Ng, </span>
                                        <span> FnB Enterpreneur</span>
                                    </div>
                                    <div>
                                        Singapore
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-center reviewslider" key={"1"}>
                            <div className="photo" style={{ backgroundImage: "url('assets/images/thumbs/review1.jpg')" }}>
                                <img src=""></img>
                            </div>
                            <div className="caption">
                                <div className="captiontop mb-20">
                                    “Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. .”
                                </div>
                                <div className="caption-bottom">
                                    <div>
                                        <span className="Name">Christine Ng, </span>
                                        <span> FnB Enterpreneur</span>
                                    </div>
                                    <div>
                                        Singapore
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>
        </div>

    )
}


export default ReviewTop;